<div id="standard-modal" role="dialog" aria-labelledby="standard-modalLabel">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title" id="standard-modalLabel">
        {{ (isNew ? 'warningWord.edit.add' : 'warningWord.edit.edit') | translate }} {{ 'warningWord.edit.alertWordsSuffix' | translate }}
      </h4>
      <button
        type="button"
        class="btn-close"
        data-bs-dismiss="modal"
        aria-hidden="true"
        (click)="close()"
      ></button>
    </div>

    <div class="modal-body">
      <form [formGroup]="formGroup" class="w-100 col-lg-8">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="form-label">{{ 'warningWord.edit.channelToLinkAlert' | translate }}</label>
            <mat-select
              class="form-control"
              formControlName="channel"
              [placeholder]="'warningWord.edit.selectPlaceholder' | translate"
              (focus)="onFocusChannel()"
            >
              @for (item of listChannel; track item) {
              <mat-option [value]="item._id">{{ item.name }}</mat-option>
              }
            </mat-select>
            <field-error-component
              [field]="'channel'"
              [label]="'warningWord.edit.channelLabel' | translate"
              [formGroup]="formGroup"
            />
          </div>

          <div class="col-12 mb-3">
            <label class="form-label"
              >{{ 'warningWord.edit.keywordsToIdentifyAlert' | translate }} <br />
              <small class="text-muted">
                {{ 'warningWord.edit.pressEnterToAddKeyword' | translate }}
              </small>
            </label>
            <input
              class="form-control"
              [placeholder]="'warningWord.edit.newKeywordPlaceholder' | translate"
              (keydown.enter)="add($event)"
              formControlName="keyword"
              (blur)="formGroup.get('keywords')?.markAsTouched()"
              autocomplete="off"
              type="text"
            />
            <field-error-component
              [field]="'keywords'"
              [label]="'warningWord.edit.keywordLabel' | translate"
              [formGroup]="formGroup"
            />

            <div class="d-flex flex-wrap gap-2 mt-2">
              @for (item of keywords; track item) {
              <div
                class="bg-secondary text-white px-2 py-1 rounded d-flex align-items-center"
              >
                <span>{{ item }}</span>
                <span
                  class="mdi mdi-close ms-2"
                  style="cursor: pointer"
                  (click)="remove(item)"
                ></span>
              </div>
              }
            </div>
          </div>

          <div class="col-12 mb-3">
            <label class="form-label">{{ 'warningWord.edit.customizeCategory' | translate }}</label>
            <div class="row">
              <div class="col-md-8">
                <input
                  formControlName="title"
                  class="form-control"
                  [placeholder]="'warningWord.edit.categoryTitlePlaceholder' | translate"
                  maxlength="100"
                />
                <field-error-component
                  [field]="'title'"
                  [label]="'warningWord.edit.titleLabel' | translate"
                  [formGroup]="formGroup"
                />
              </div>
              <div class="col-md-4 d-flex align-items-center gap-2">
                <mat-form-field class="w-100">
                  <input
                    matInput
                    formControlName="bgColor"
                    class="form-control"
                  />
                </mat-form-field>
                <div
                  class="border rounded-circle d-flex align-items-center justify-content-center"
                  style="width: 50px; height: 50px"
                >
                  <input
                    [(colorPicker)]="color"
                    [style.background]="color"
                    (colorPickerSelect)="selectColor()"
                    class="rounded-circle"
                    style="width: 40px; height: 40px; border: none"
                  />
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 mb-4">
            <label class="form-label"
              >{{ 'warningWord.edit.alertWordPreview' | translate }}</label
            >
            <div>
              <span
                class="px-3 py-2 rounded"
                [ngStyle]="{
                  'background-color': $safeNavigationMigration(formGroup.get('bgColor')?.value),
                  'color': ($safeNavigationMigration(formGroup.get('bgColor')?.value) | readableText: '#ffffff')
                }"
              >
                {{ formGroup.get("title")?.value }}
              </span>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-light" (click)="close()">
        {{ 'warningWord.edit.cancel' | translate }}
      </button>
      <button
        type="submit"
        class="btn btn-primary"
        [mat-dialog-close]="true"
        [disabled]="!formGroup.valid || loading"
        (click)="save()"
      >
        {{ (isNew ? 'warningWord.edit.save' : 'warningWord.edit.edit') | translate }}
        @if (loading) {
        <mat-spinner [diameter]="25" [color]="'accent'" mode="indeterminate" />
        }
      </button>
    </div>
  </div>
</div>
